import React from "react";

import css from "./Divider.module.scss";

type DividerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHRElement>, HTMLHRElement> & {
	/**
	 * Custom class name to apply to the divider
	 **/
	className?: string;
	/**
	 * Orientation of the divider
	 **/
	orientation?: "horizontal" | "vertical";
};

/**
 * Layout component used to visually separate content in a group.
 * Displays a thin horizontal line, and renders a `hr` tag.
 */
export const Divider = ({ className, orientation = "horizontal", ...rest }: DividerProps) => {
	const orientationClass = orientation === "vertical" ? css.vertical : "";
	return <hr className={`${css.divider} ${orientationClass} ${className ?? ""}`} {...rest} role="separator" />;
};
